<div class="userSearchWithDropdown">
  @if(includeSearchExistingLabel) {
    <label class="form-label me-2" for="{{role.toLocaleLowerCase()}}Username{{ i }}">Search Existing</label>
  }
  <input
    #input
    id="{{role.toLocaleLowerCase()}}Username{{ i }}"
    class="form-control"
    required
    aria-required="true"
    [formControl]="control"
    #typeAhead="ngbTypeahead"
    [ngbTypeahead]="searchUser"
    [inputFormatter]="formatUsername"
    [resultTemplate]="itemTemplate"
    [class.is-invalid]="checkInvalid(control)"
    [attr.aria-invalid]="invalidSelection"
    [attr.aria-describedby]="invalidSelection ? ariaDescribedBy : ''"
    (selectItem)="itemSelected($event)"
    [placeholder]="placeholderText"
    container="body"
    >
  <ng-template #itemTemplate let-r="result" let-index="index">
    <div
      class="typeahead-item"
      [style.width.px]="inputRef.nativeElement.clientWidth - 25"
      >
      {{formatUsername(r) + ': ' + r.fullName}}
    </div>
  </ng-template>
  @if (isSearching) {
    <i class="fa fa-circle-notch fa-spin d-inline-block input-group-append text-muted my-auto mx-2" aria-label="Searching..." id="isSearching{{ i }}"></i>
  }
</div>
